var map = {
	"./vuurvogel-hero-x1200.jpg": 39682,
	"./vuurvogel-hero-x1200.webp": 84527,
	"./vuurvogel-hero-x768.jpg": 28074,
	"./vuurvogel-hero-x768.webp": 92247,
	"./vuurvogel-hero-x800.jpg": 3775,
	"./vuurvogel-hero-x800.webp": 30156,
	"./vuurvogel-hero.jpg": 7996,
	"./vuurvogel-x1100.jpg": 83132,
	"./vuurvogel-x1100.webp": 83877,
	"./vuurvogel-x768.jpg": 96001,
	"./vuurvogel-x768.webp": 834,
	"./vuurvogel-x800.jpg": 2000,
	"./vuurvogel-x800.webp": 49609,
	"./word-cloud.png": 55538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79183;